import { ChevronLeft, ChevronRight } from "lucide-react";

import { useTranslation } from "@/i18n";
import { Button } from "@/components/ui/button";

interface PaginationProps {
  /** 0-indexed page. */
  page: number;
  pageSize: number;
  /** Whether we believe a next page exists. The backend audit
   * endpoint doesn't return a total count, so the page consults
   * the current items.length === pageSize as a heuristic. */
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

export function Pagination({
  page,
  pageSize,
  hasNext,
  onPrev,
  onNext,
}: PaginationProps) {
  const { t } = useTranslation();
  const start = page * pageSize + 1;
  const end = page * pageSize + pageSize;
  return (
    <div className="flex items-center justify-between gap-3">
      <p className="text-xs text-neutral-500">
        {t("shared.pagination.rangeLabel", { start, end })}
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onPrev}
          disabled={page === 0}
        >
          <ChevronLeft size={14} />
          {t("shared.pagination.previous")}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onNext}
          disabled={!hasNext}
        >
          {t("shared.pagination.next")}
          <ChevronRight size={14} />
        </Button>
      </div>
    </div>
  );
}
